'use client';

import { LazyMotion, m, type HTMLMotionProps } from 'motion/react';
import * as React from 'react';

import { loadMotionFeatures } from './loadMotionFeatures';
import { prefersReducedMotion } from './prefers-reduced-motion';

export function FadeIn({
  children,
  ...props
}: HTMLMotionProps<'div'> & { children: React.ReactNode }) {
  const reduced = prefersReducedMotion();
  return (
    <LazyMotion features={loadMotionFeatures} strict>
      <m.div
        initial={reduced ? false : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: reduced ? 0 : 0.35, ease: [0.16, 1, 0.3, 1] }}
        {...props}
      >
        {children}
      </m.div>
    </LazyMotion>
  );
}
